const searchBar = `</search>
<div class="hello-message">
    Your world weather finder
</div>
<div class="search-container initial-position">
    <input type="text" id="search-location" placeholder="Search location">
    <img src="./img/cloud-search.svg" alt="search" id="search-button">
</div>
<div class="display-container">

</div>`;

export default searchBar;
